<div class="w-full p-5 flex flex-wrap mobile:gap-2" *ngIf="paymentMethod">

    <app-cardlogo [cardName]="'card'"></app-cardlogo>
    <div class="flex flex-col">
        <p class="font-bold text-sm">{{ paymentMethod.brand | titlecase }} {{ 'settings.card.ending_in' | transloco }}
            {{
            paymentMethod.last4 }}</p>
        <p class="text-neutral-500 text-sm">{{
            'settings.card.expires' | transloco }} {{ paymentMethod.exp_month }}/{{ paymentMethod.exp_year }}
        </p>
    </div>
    <button (click)="setAsDefaultClick()" title="{{ 'settings.subscription.set_as_default' | transloco }}"
        *ngIf="!paymentMethod.is_default">
        <a class="text-primary hover:underline ml-2 hover:cursor-pointer">{{
            'settings.card.change' | transloco }}</a>
    </button>
</div>